exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-login__box{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-top:20px}.account-login__button{width:120px}.account-login__link{-ms-flex:1 1;flex:1 1}.account-login__register{margin-top:36px;text-align:center}.account-login__register-link{margin-left:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/Account/Login/AccountLogin/AccountLogin.scss
// module id = 868
// module chunks = 1